<template>
    <configuration-c>
        <header-c>
        </header-c>

        <div id="main-body" class="row pb-5">
            <div class="col-12">
                <div class="d-flex justify-content-center">
                    <div class="width-n">

                        <!-- Layout body -->
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="row detail-footer-divider"
            v-if="this.$inertia.page.component == 'Inventory/Item' && (showMiniBanners || showFeaturedItems)"
        >
            <div class="col-12">
                <div class="d-flex justify-content-center">
                    <div class="width-n py-3">
                        <app-mini-banners-c
                            v-if="showMiniBanners"
                        >
                        </app-mini-banners-c>

                        <app-featured-items-c
                            v-if="showFeaturedItems"
                            :load-from-cache="true"
                        >
                        </app-featured-items-c>
                    </div>
                </div>
            </div>
        </div>

        <whatsapp-button
            v-if="showBtnWhatsapp"
            :number="whatsappNumber"
            :message="whatsappMessage"
        ></whatsapp-button>

        <footer-c>
        </footer-c>
    </configuration-c>
</template>

<script>
import ConfigurationC from '../../../components/Shared/General/LoadConfigurationComponent.vue';
import WhatsappButton from '../../../components/Shared/General/WhatsAppButtonComponent.vue';
import HeaderC from '../../../components/Template1/General/HeaderComponent.vue';
import FooterC from '../../../components/Shared/General/FooterComponent.vue';

import AppFeaturedItemsC from '../../../components/Template1/Home/FeaturedItemsComponent.vue';
import AppMiniBannersC from '../../../components/Template1/Home/MiniBannersComponent.vue';

export default {

    components: {
        ConfigurationC,
        WhatsappButton,
        HeaderC,
        FooterC,

        AppFeaturedItemsC,
        AppMiniBannersC,
    },

    data() {

        return {
            showMiniBanners: false,
            showFeaturedItems: false,
            showBtnWhatsapp: false,
            whatsappNumber: String(),
            whatsappMessage: String(),
        };

    },

    mounted() {

        setTimeout(() => {

            this.showMiniBanners = Number(localStorage.getItem('mini_banners_active'));
            this.showFeaturedItems = Number(localStorage.getItem('featured_items_active'));
            this.loadWhatsAppData();

        }, 2000);

    },

    methods: {
        loadWhatsAppData() {

            const companyData = $.parseJSON(localStorage.getItem('company_data'));

            if (companyData && companyData?.whatsapp?.floating_button) {

                this.showBtnWhatsapp = companyData.whatsapp.floating_button;
                this.whatsappNumber = companyData.whatsapp.whatsapp_info.country.dial_code.replace(/[^a-zA-Z0-9 ]/g, '') + companyData.whatsapp.whatsapp_info.number;
                this.whatsappMessage = companyData.whatsapp.whatsapp_info.message;

            }

        },
    },

};
</script>

<style>

</style>
